import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { getFormData, Modal, MsToString } from '../../common';
import { QuizShowAdminRepository } from '../../repository/QuizShowAdminRepository';
import { NavBar } from './NavBar';

const repository = new QuizShowAdminRepository();

class QuizAdminGameQuizListPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {},
      game: {},
      quizList: [],
      selectedQuiz: {}
    };
  }

  componentDidMount() {
    const { gameId } = (this.props.match.params);
    this.fetchMe();
    this.fetchGame({ gameId });
    this.fetchQuizList({ gameId });
  }

  onClickCategory({ quizId }) {
    this.fetchQuiz({ id: quizId });
    window.$("#game-detail-quiz-update-modal").modal("show");
  }

  onSubmitCreateQuiz(e) {
    e.preventDefault();
    const { gameId } = (this.props.match.params);
    const formData = getFormData(e.target);
    const request = {
      ...formData,
      gameId,
      exams: [formData.exam1, formData.exam2, formData.exam3].filter(v => v !== null && v !== undefined)
    };

    repository.createQuiz(request, () => {
      window.$("#game-detail-quiz-create-modal").modal("hide");
      e.target.reset();
      this.fetchQuizList({ gameId });
    });
  }

  onSubmitUpdateQuiz(e) {
    e.preventDefault();
    const { gameId } = (this.props.match.params);
    const formData = getFormData(e.target);
    const request = {
      ...formData,
      gameId,
      exams: [formData.exam1, formData.exam2, formData.exam3].filter(v => v !== null && v !== undefined)
    };

    repository.updateQuiz(request, () => {
      window.$("#game-detail-quiz-update-modal").modal("hide");
      e.target.reset();
      this.fetchQuizList({ gameId });
    });
  }

  onClickDeleteQuiz({ quizId }) {
    const { gameId } = (this.props.match.params);
    const answer = window.confirm("Are you sure?");
    answer && repository.deleteQuiz({ id: quizId }, () => {
      window.$("#game-detail-quiz-update-modal").modal("hide");
      this.fetchQuizList({ gameId });
    });
  }

  fetchMe = () => {
    repository.findMe(null, (data) => {
      this.setState({ user: data });
    });
  }

  fetchGame = ({ gameId }) => {
    repository.findGame({ id: gameId }, (data) => {
      this.setState({ game: data });
    });
  }

  fetchQuizList = ({ gameId }) => {
    repository.searchQuiz({ gameId }, (data) => {
      this.setState({ quizList: data.quizzes });
    });
  }

  fetchQuiz = (params, callback) => {
    repository.findQuiz(params, (data) => {
      this.setState({ selectedQuiz: data });
      callback && callback(data);
    });
  }

  render() {
    const { user, game, quizList, selectedQuiz } = this.state;
    const unload = (user.id === undefined);
    const loaded = !unload;
    const isLogin = (user.id !== null);

    return (
      <>
        <NavBar user={user} />

        <div className={"container"}>
          <div style={{ marginTop: 30, fontSize: 32 }}>{game.name || " "}</div>

          {loaded && isLogin && (
            <div style={{ marginTop: 30 }}>
              <button
                style={{ width: 100 }}
                className={"btn btn-primary"}
                data-toggle={"modal"}
                data-target={"#game-detail-quiz-create-modal"}>퀴즈생성</button>
            </div>
          )}

          {loaded && isLogin && (
            <div style={{ marginTop: 10 }}>
              <QuizAdminGameQuizList quizList={quizList} onClickCategory={this.onClickCategory.bind(this)} />
            </div>
          )}
        </div>

        <Modal id={"game-detail-quiz-create-modal"} title={"퀴즈생성"}>
          <QuizAdminQuizCreate onSubmit={this.onSubmitCreateQuiz.bind(this)} />
        </Modal>

        <Modal id={"game-detail-quiz-update-modal"} title={"퀴즈수정"}>
          <QuizAdminQuizUpdate
            item={selectedQuiz}
            onClickDeleteQuiz={this.onClickDeleteQuiz.bind(this)}
            onSubmit={this.onSubmitUpdateQuiz.bind(this)} />
        </Modal>
      </>
    );
  }
}

const QuizAdminGameQuizList = (props) => {
  const { quizList } = props;
  const [questionShow, setQuestionShow] = useState(false);
  const [answerShow, setAnswerShow] = useState(false);

  const onClickQuestionToggle = (e) => {
    e.preventDefault();
    setQuestionShow(!questionShow);
  };

  const onClickAnswerToggle = (e) => {
    e.preventDefault();
    setAnswerShow(!answerShow);
  };

  const onClickCategory = (e) => {
    e.preventDefault();
    const { quizid } = e.target.dataset;
    props.onClickCategory && props.onClickCategory({ quizId: quizid });
  };

  return (
    <>
      <div style={{ textAlign: "left" }}>
        <button
          className={`btn btn-sm ${questionShow ? "btn-primary" : "btn-outline-primary"}`}
          style={{ width: 80 }}
          onClick={onClickQuestionToggle}>문제 {questionShow ? "ON" : "OFF"}</button>
        &nbsp;
        <button
          className={`btn btn-sm ${answerShow ? "btn-primary" : "btn-outline-primary"}`}
          style={{ width: 80 }}
          onClick={onClickAnswerToggle}>정답 {answerShow ? "ON" : "OFF"}</button>
      </div>
      <table className={"table"} style={{ marginTop: 10 }}>
        <thead>
          <tr>
            <th style={{ width: "70%" }}>카테고리</th>
            <th style={{ width: "15%" }}>일반</th>
            <th style={{ width: "15%" }}>제한시간</th>
          </tr>
        </thead>
        <tbody>
          {quizList.map((item, idx) => (
            <tr key={idx}>
              <td>
                <Link to={"/"} onClick={onClickCategory} data-quizid={item.id}>
                  {idx + 1}. {item.category} {item.score}점
                  {questionShow && (<><br />Q. {item.question}</>)}
                  {answerShow && (<><br />A. {item.answer}</>)}
                </Link>
              </td>
              <td>{item.imageUrl ? "이미지" : "일반"}</td>
              <td><MsToString ms={item.timeLimit} fixed={0} /></td>
            </tr>
          ))}
          {!quizList.length && (
            <tr><td colSpan={3}>NOT FOUND</td></tr>
          )}
        </tbody>
      </table>
    </>
  );
};

const ScoreSelectBox = (props) => {
  const value = props.defaultValue || 100;
  return (
    <select className={"form-control"} name={"score"} key={value} defaultValue={value}>
      <option value={100}>100점</option>
      <option value={100 * 2}>200점</option>
      <option value={100 * 3}>300점</option>
      <option value={100 * 4}>400점</option>
      <option value={100 * 5}>500점</option>
    </select>
  );
};

const TimeLimitSelectBox = (props) => {
  const value = props.defaultValue || 1000 * 10;
  return (
    <select className={"form-control"} name={"timeLimit"} key={value} defaultValue={value}>
      <option value={1000}>1초</option>
      <option value={1000 * 10}>10초</option>
      <option value={1000 * 15}>15초</option>
      <option value={1000 * 30}>30초</option>
      <option value={1000 * 60}>1분</option>
      <option value={1000 * 60 * 10}>10분</option>
      <option value={1000 * 60 * 60}>1시간</option>
    </select>
  );
};

const QuizAdminQuizCreate = (props) => {
  return (
    <div>
      <form onSubmit={props.onSubmit}>
        <div className={"form-group text-left"}>
          <label>유형</label>
          <input className={"form-control"} name={"category"} autoComplete={"off"} placeholder={"ex) 테스트, 넌센스, 수학"} />
        </div>
        <div className={"form-group text-left"}>
          <label>질문</label>
          <input className={"form-control"} name={"question"} autoComplete={"off"} />
        </div>
        <div className={"form-group text-left"}>
          <label>이미지 URL</label>
          <input className={"form-control"} name={"imageUrl"} autoComplete={"off"} />
        </div>
        <div className={"form-group row"}>
          <div className={"col text-left"}>
            <label>점수</label>
            <ScoreSelectBox />
          </div>
          <div className={"col text-left"}>
            <label>제한시간</label>
            <TimeLimitSelectBox />
          </div>
        </div>
        <div className={"form-group row"}>
          <div className={"col"}>
            <label>정답</label>
            <input className={"form-control"} name={"answer"} autoComplete={"off"} />
          </div>
          <div className={"col"}>
            <label>보기1</label>
            <input className={"form-control"} name={"exam1"} autoComplete={"off"} />
          </div>
          <div className={"col"}>
            <label>보기2</label>
            <input className={"form-control"} name={"exam2"} autoComplete={"off"} />
          </div>
          <div className={"col"}>
            <label>보기3</label>
            <input className={"form-control"} name={"exam3"} autoComplete={"off"} />
          </div>
        </div>
        <br />
        <div className={"form-group"}>
          <input className={"form-control btn btn-primary"} type={"submit"} value={"생성하기"} />
        </div>
      </form>
    </div>
  );
};

const QuizAdminQuizUpdate = (props) => {
  const { item } = props;
  return (
    <div>
      <form onSubmit={props.onSubmit}>
        <input type={"hidden"} name={"id"} defaultValue={item.id} />
        <div className={"form-group text-left"}>
          <label>유형</label>
          <input className={"form-control"} name={"category"} autoComplete={"off"} defaultValue={item.category} />
        </div>
        <div className={"form-group text-left"}>
          <label>질문</label>
          <input className={"form-control"} name={"question"} autoComplete={"off"} defaultValue={item.question} />
        </div>
        <div className={"form-group text-left"}>
          <label>이미지 URL</label>
          <input className={"form-control"} name={"imageUrl"} autoComplete={"off"} defaultValue={item.imageUrl} />
        </div>
        <div className={"form-group row"}>
          <div className={"col text-left"}>
            <label>점수</label>
            <ScoreSelectBox defaultValue={item.score} />
          </div>
          <div className={"col text-left"}>
            <label>제한시간</label>
            <TimeLimitSelectBox defaultValue={item.timeLimit} />
          </div>
        </div>
        <div className={"form-group row"}>
          <div className={"col"}>
            <label>정답</label>
            <input className={"form-control"} name={"answer"} autoComplete={"off"} defaultValue={item.answer} />
          </div>
          <div className={"col"}>
            <label>보기1</label>
            <input className={"form-control"} name={"exam1"} autoComplete={"off"} defaultValue={item.exams && item.exams[0]} />
          </div>
          <div className={"col"}>
            <label>보기2</label>
            <input className={"form-control"} name={"exam2"} autoComplete={"off"} defaultValue={item.exams && item.exams[1]} />
          </div>
          <div className={"col"}>
            <label>보기3</label>
            <input className={"form-control"} name={"exam3"} autoComplete={"off"} defaultValue={item.exams && item.exams[2]} />
          </div>
        </div>
        <br />
        <div className={"form-group"}>
          <input className={"form-control btn btn-primary"} type={"submit"} value={"수정"} />
        </div>
        <div className={"form-group"}>
          <input className={"form-control btn btn-danger"} onClick={() => props.onClickDeleteQuiz({ quizId: item.id })} type={"button"} value={"삭제"} />
        </div>
      </form>
    </div>
  );
};

export { QuizAdminGameQuizListPage };
